<template>
  <section class="page-container">
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'">
        <el-table-column
          label="File Name">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="skyBlue bold">{{ row.excel_file_nm }}</span><br>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Created Date">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Exported Date">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.success_date.split(" ")[0] }}</span><br>
              <span> {{ row.success_date.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Handler">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="bold">{{ row.cs_name }}</span><br>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="160px"
          type=index
          label="Action">
          <template slot-scope="scope">
            <div
              v-if="loading&&scope.$index==index"
              class="loading-content">
              <span
                v-loading="true"
                :customClass="'loading-class'"
              ></span>
              <span class="loading-text">{{ isDel ? 'Delete' : 'Exporting' }}</span>
            </div>
            <div
              v-else
              class="flex">
              <span
                class="skyBlue pointer"
                @click="handleDown(scope.row,scope.$index)">Download</span>
              <span
                class="color-del mg-l-8 pointer"
                @click="handleDel(scope.row,scope.$index)">Delete</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {delMarketingExport, getMarketingList} from '@api/marketing'

export default {
  name: 'marketing-report-list',
  props:{
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData:[],
      loading:false,
      isDel:false,
      index:-1
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.currentChange(1)
  },
  methods: {
    handleDel({id},index){
      this.index = index
      this.loading =true
      this.isDel  = true
      this.network().delMarketingExport({id:id})
    },
    handleDown({file_url},index){
      this.index = index
      this.isDel  = false
      this.loading =true
      if(file_url){
        window.open(file_url, '_blank')
        this.loading = false
      }
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getMarketingList()
    },
    network() {
      return {
        getMarketingList: async () => {
          const {data} = await getMarketingList({
            page: this.pageConfig.currentPage,
          })

          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        delMarketingExport: async (params) => {
          const {data} = await delMarketingExport({
            ...params,
            hideLoading:true
          })
          this.tableData.splice(this.index,1)
          this.isDel = false
          this.loading = false
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/marketing/marketing';
/deep/.tableHeader th .cell {
   padding-left: 10px;
}
/deep/.el-table tr td .cell{
  padding-left: 10px;
}
.loading-content{
  .loading-text{
    margin-left: 30px;
  }
}
/deep/.el-loading-mask{
  top: 18px;
}
/deep/.el-loading-spinner{
  display: flex;
  align-items: center;
  width: 120px ;
  .circular{
    height: 20px;
    width: 20px;
    margin-top: 0;
    .path{
      stroke:#6A737D
    }
  }
  .el-loading-text{
    color:#6A737D;
    margin-left: 8px;
  }
}

</style>
